module.exports = __webpack_public_path__ + "static/media/36.704ea910.png";